/**
 * dms门店管理接口
 * Created by stonewang on 2017/8/29.
 */
import {config, request} from 'Utils';

//门店列表
export function list(param) {
  return request(`${config.server}/api/v1/dms/store/list`, {
    method: 'post',
    body: param,
  });
}
//新增或修改门店
export function insertByPc(param) {
  /*
   {
   "active": 0,
   "belongArea": 0,
   "belongDealer": 0,
   "belongEmployee": 0,
   "city": "string",
   "closeDate": "2017-09-07T07:21:57.728Z",
   "code": "string",
   "county": "string",
   "name": "string",
   "openDate": "2017-09-07T07:21:57.728Z",
   "operateWay": 0,
   "province": "string",
   "sellVolume": 0,
   "shopowner": "string",
   "shopownerPhone": "string",
   "storeAddress": "string",
   "storeArea": 0,
   "storeEmployeeNum": 0,
   "storePhone": "string",
   "storeType": 0
   }
  * */
  return request(`${config.server}/api/v1/dms/store/insertByPc`, {
    method: 'post',
    body: param,
  });
}
//修改门店
export function modifyByPc(param) {
  return request(`${config.server}/api/v1/dms/store/modifyByPc`, {
    method: 'post',
    body: param,
  });
}
//门店详情
export function detail(param) {
  return request(`${config.server}/api/v1/dms/store/detail?id=${param}`);
}



// WEBPACK FOOTER //
// ./src/service/store/index.js